import { LookupType } from '../lookup/lookup-type';

export interface GlAccount {
  id?: number;
  name?: string;
  number?: string;
  active?: boolean;
  glAccountTypeId?: number;
  glAccountType?: LookupType;
  zoneId?: number;
  zone?: LookupType;
}

export enum GlAccountStatus {
  Active,
  Inactive,
}
